import React, { useState, useCallback } from "react"

const ResultLanguageContext = React.createContext({
  availableLanguages: null,
  resultLanguage: null,
  setAvailableLanguages: () => {},
  setResultLanguage: () => {},
})

export const ResultLanguageProvider = ({ children }) => {
  const [availableLanguages, setAvailableLanguages] = useState(null)
  const [resultLanguage, setResultLanguage] = useState(null)

  const clearResultLanguage = useCallback(() => {
    setAvailableLanguages(null)
    setResultLanguage(null)
  }, [])

  return (
    <ResultLanguageContext.Provider
      value={{
        availableLanguages,
        resultLanguage,
        setAvailableLanguages,
        setResultLanguage,
        clearResultLanguage,
      }}
    >
      {children}
    </ResultLanguageContext.Provider>
  )
}

export default ResultLanguageContext
